import React from 'react';
import glamorous from 'glamorous';
import Category from './categoryTiles';

const TileContainer = glamorous.div(
  {
    width: '100%',
    textAlign: 'center',
  },
  ({ classProp }) => {
    return classProp ? { height: 'auto', background: 'white' } : '';
  }
);

const Tile = props => {
  let tiles = props.renderTiles;

  let renderTiles = '';

  switch (tiles) {
    case 'categories':
      renderTiles = <Category {...props} />;
      break;
    default:
      renderTiles = <div />;

      break;
  }

  return (
    <TileContainer classProp={props.classprop === 'panel'} id={props.id}>
      <div className='card_container containerTile' id={props.id}>
        {renderTiles}
      </div>
    </TileContainer>
  );
};

export default Tile;
